// extracted by mini-css-extract-plugin
module.exports = {"menucardBadge":"styles_menucardBadge__1xfIs","largeTag":"styles_largeTag__2WYjg"};